<template>
  <div id="thisOrThatTwo"></div>
</template>

<script>
export default {
  name: "ThisOrThatTwo",
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({
        question: "Which do you prefer?",
        optionA: "Remote Work",
        optionB: "Office Work",
        chip: "This or That",
      }),
    },
    scale: {
      type: Number,
      required: true,
      default: 0.8,
    },
  },
  computed: {
    workspace() {
      return this.$store.state.workspace;
    },
  },
  mounted() {
    this.render();
  },
  watch: {
    scale: {
      handler() {
        this.render();
      },
      immediate: true,
      deep: true,
    },
    data: {
      handler() {
        this.render();
      },
      deep: true,
    },
  },
  methods: {
    render() {
      const el = document.getElementById("thisOrThatTwo");
      if (!el) return;
      el.innerHTML = this.exportHTML();
    },
    exportHTML(exporting = false) {
      const containerSize = exporting ? 1200 : 1200 * this.scale;
      const questionSize = exporting ? 32 : 32 * this.scale;
      const optionSize = exporting ? 52 : 52 * this.scale;
      const logoHeight = exporting ? 40 : 40 * this.scale;
      const chipSize = exporting ? 20 : 20 * this.scale;
      const vsSize = exporting ? 36 : 36 * this.scale;

      const logoSrc = this.workspace?.branding?.logo?.light || "";
      const primaryColor =
        this.workspace?.branding?.color?.primary || "#10a37f";

      let openingDiv = `<div style="height: ${containerSize}px; width: ${containerSize}px; aspect-ratio: 1 / 1;">`;

      let html = `
        ${openingDiv}
        <div
          style="
            background: linear-gradient(135deg, #0f0f0f 0%, #1a1a2e 25%, #16213e 50%, #1a1a2e 75%, #0f0f0f 100%);
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
            width: 100%;
            aspect-ratio: 1 / 1;
            position: relative;
            overflow: hidden;
          "
        >
          <!-- Gradient orb effects -->
          <div style="
            position: absolute;
            top: 20%;
            left: -10%;
            width: 50%;
            height: 50%;
            background: radial-gradient(circle, ${primaryColor}30 0%, transparent 70%);
            pointer-events: none;
          "></div>
          <div style="
            position: absolute;
            bottom: 20%;
            right: -10%;
            width: 50%;
            height: 50%;
            background: radial-gradient(circle, #6366f130 0%, transparent 70%);
            pointer-events: none;
          "></div>

          <!-- Header with logo -->
          <div style="padding: 8%; position: relative; z-index: 1;">
            <img src="${logoSrc}" height="${logoHeight}px" alt="" style="opacity: 0.9;" />
          </div>

          <!-- Content -->
          <div style="padding: 0 8%; position: relative; z-index: 1; flex: 1; display: flex; flex-direction: column; justify-content: center;">
            <div style="
              font-size: ${questionSize}px;
              font-weight: 400;
              color: rgba(255, 255, 255, 0.6);
              text-align: center;
              margin-bottom: 40px;
            ">${this.data.question}</div>

            <div style="display: flex; align-items: center; gap: 20px;">
              <!-- Option A -->
              <div style="
                flex: 1;
                background: rgba(255, 255, 255, 0.1);
                backdrop-filter: blur(10px);
                border: 2px solid ${primaryColor};
                border-radius: 20px;
                padding: 48px 24px;
                text-align: center;
              ">
                <div style="
                  font-size: ${optionSize}px;
                  font-weight: 600;
                  color: #ffffff;
                  line-height: 1.2;
                ">${this.data.optionA}</div>
              </div>

              <!-- VS -->
              <div style="
                font-size: ${vsSize}px;
                font-weight: 700;
                background: linear-gradient(135deg, ${primaryColor} 0%, #6366f1 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
              ">VS</div>

              <!-- Option B -->
              <div style="
                flex: 1;
                background: rgba(255, 255, 255, 0.1);
                backdrop-filter: blur(10px);
                border: 2px solid #6366f1;
                border-radius: 20px;
                padding: 48px 24px;
                text-align: center;
              ">
                <div style="
                  font-size: ${optionSize}px;
                  font-weight: 600;
                  color: #ffffff;
                  line-height: 1.2;
                ">${this.data.optionB}</div>
              </div>
            </div>
          </div>

          <!-- Footer with chip -->
          <div style="padding: 8%; position: relative; z-index: 1;">
            <div style="display: flex; justify-content: center;">
              <span
                style="
                  display: inline-block;
                  background: rgba(255, 255, 255, 0.1);
                  backdrop-filter: blur(10px);
                  color: #ffffff;
                  font-size: ${chipSize}px;
                  font-weight: 500;
                  border-radius: 999px;
                  padding: 10px 24px;
                  letter-spacing: 0.05em;
                  text-transform: uppercase;
                  border: 1px solid rgba(255, 255, 255, 0.15);
                "
              >
                ${this.data.chip}
              </span>
            </div>
          </div>
        </div>
      </div>
      `;

      return html;
    },
  },
};
</script>

<style scoped></style>
